/* eslint-disable react/no-danger */
import React, { Fragment, useState } from 'react';
import { Element, Link as ScrollLink } from 'react-scroll';
import EditorViewer from '@common/editorViewer';
import { matchChallengeKeys } from '@repository/match';
import ChallengeTabList from './tabs';
import JoinPositionList from './joinPositionList';
import MatchingChallengeVO, { MatchingChallengeTabVO } from '@domain/vo/challenge/MatchingChallengeVO';
import { ChallengeStatus } from '@domain/constant/challenge/challengeStatusType';
import { queryClient } from '@utils/queryClient';

import classnames from 'classnames/bind';
import styles from './challengeDetailInfo.module.scss';
const cx = classnames.bind(styles);

interface ChallengeDetailInfoProps {
  challengeSn: number;
}

const detailInfoEl = (detailInfo: MatchingChallengeTabVO, idx: number) => {
  if (idx === 0) {
    return (
      <Fragment key={idx}>
        <Element className={cx('detailInfoWrap')} name={`challengeTab_${idx}`}>
          <div className={cx('detailInfoTitle')}>{detailInfo.name}</div>
          <EditorViewer value={detailInfo.contents} />
        </Element>
        <Element className={cx('detailInfoWrap')} name={`challengeTab_${idx + 1}`}>
          <JoinPositionList />
        </Element>
      </Fragment>
    );
  }

  return (
    <Element className={cx('detailInfoWrap')} key={idx} name={`challengeTab_${idx + 1}`}>
      <div className={cx('detailInfoTitle')}>{detailInfo.name}</div>
      <EditorViewer value={detailInfo.contents} />
    </Element>
  );
};

const ChallengeDetailInfo = ({ challengeSn }: ChallengeDetailInfoProps) => {
  const [currentTabIdx, setCurrentTabIdx] = useState(0);
  const data = queryClient.getQueryData<MatchingChallengeVO>([...matchChallengeKeys, challengeSn]);

  if (!data) return null;

  const detailInfo = data.challengeTabs.map((detailInfo, idx) => detailInfoEl(detailInfo, idx));
  const status = Object.keys(ChallengeStatus).filter((statusType) => statusType === data.challengeStatus);

  return (
    <div className={cx('wrap')}>
      <div className={cx('infoTitleArea')}>
        <em className={cx('infoTitle')}>{data.title}</em>
        <div className={cx('dateArea')}>
          <span className={cx('dateTitle')}>진행기간</span>
          <span className={cx('date')}>{data.postDateRangeTimeForm}</span>
          <span className={cx('badge', ...status)}>
            {data.challengeStatus === 'PROGRESS' ? data.leftDays : data.challengeStatusText}
          </span>
          <ScrollLink
            to={`challengeTab_${1}`}
            smooth={true}
            className={cx('listBtn')}
            offset={-90}
            spy={true}
            role={'button'}
          >
            리스트 바로 확인하기
          </ScrollLink>
        </div>
      </div>

      <div className={cx('detailInfoArea')}>
        <div className={cx('detailInfoInner')}>{detailInfo}</div>
        <ChallengeTabList
          challengeTabs={data.challengeTabs}
          currentTabIdx={currentTabIdx}
          setCurrentTabIdx={setCurrentTabIdx}
        />
      </div>
    </div>
  );
};

export default ChallengeDetailInfo;
